"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
var _Content = _interopRequireDefault(require("../Content"));
var _populateMetric = _interopRequireDefault(require("../populateMetric.js"));
var _utils = require("../Settings/utils.js");
var _config = require("../config.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var VizReport = function VizReport(props) {
  var metrics = props.metrics,
    vizData = props.vizData,
    deployments = props.deployments,
    settings = props.settings,
    overrideInitialVisualizeSettings = props.overrideInitialVisualizeSettings;
  var filteredMetrics = (0, _react.useMemo)(function () {
    return metrics.slice(0, _config.REPORT_METRICS_LIMIT);
  }, [metrics]);
  var _useMemo = (0, _react.useMemo)(function () {
      var totalMetrics = filteredMetrics.length;
      var loadedMetrics = filteredMetrics.filter(function (item) {
        return item.variableId in vizData;
      }).length;
      return [loadedMetrics === totalMetrics, Math.floor(loadedMetrics / totalMetrics * 100)];
    }, [filteredMetrics, vizData]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    allVizDataLoaded = _useMemo2[0],
    vizLoadedPercent = _useMemo2[1];
  var metricsMatch = (0, _react.useMemo)(function () {
    if (!allVizDataLoaded) {
      return {};
    }
    return filteredMetrics.reduce(function (obj, item) {
      obj[item.reportHeader] = item;
      return obj;
    }, {});
  }, [allVizDataLoaded, filteredMetrics]);
  var getCrossMetric = function getCrossMetric(metricSettings) {
    if (!metricSettings.compareWith) {
      return null;
    }
    var reportHeader = metricSettings.compareWith.replace('variables.', '');
    return (0, _populateMetric["default"])(metricsMatch[reportHeader]);
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, !allVizDataLoaded ? /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: true,
    type: "inline",
    percentage: vizLoadedPercent
  }) : /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Report, null, filteredMetrics.map(function (metric) {
    var currentMetric = (0, _populateMetric["default"])(metric);
    var currentMetricSettings = (0, _utils.getActualMetricSettings)(currentMetric, settings[currentMetric.variableId], overrideInitialVisualizeSettings);
    return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, {
      key: metric.variableId
    }, /*#__PURE__*/_react["default"].createElement(_Content["default"], {
      currentMetric: currentMetric,
      currentMetricSettings: currentMetricSettings,
      deployments: deployments,
      currentCrossMetric: getCrossMetric(currentMetricSettings),
      data: vizData[currentMetric.variableId]
    }));
  })));
};
VizReport.propTypes = {
  metrics: _propTypes["default"].array,
  vizData: _propTypes["default"].object,
  deployments: _propTypes["default"].array,
  settings: _propTypes["default"].object,
  overrideInitialVisualizeSettings: _propTypes["default"].object
};
var _default = VizReport;
exports["default"] = _default;